export const sportsPrefix = 'sports';
export const queryBetJwtToken = () => [sportsPrefix, 'betJwtToken'];
